"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSelectedAddress = exports.selectRelationshipOfferings = exports.selectLowestPlanPrice = exports.selectHandsets = exports.selectBroadband = exports.selectAddressSuggestions = exports.selectAddressError = void 0;
const selectHandsets = instanceId => state => {
  return state.drools[instanceId].productCatalog.handsets;
};
exports.selectHandsets = selectHandsets;
const selectBroadband = instanceId => state => {
  return state.drools[instanceId].productCatalog.broadband;
};
exports.selectBroadband = selectBroadband;
const selectRelationshipOfferings = instanceId => state => {
  return state.drools[instanceId].productCatalog.productRelationshipOffering;
};
exports.selectRelationshipOfferings = selectRelationshipOfferings;
const selectAddressSuggestions = instanceId => state => {
  return state.drools[instanceId].productCatalog.addresses;
};
exports.selectAddressSuggestions = selectAddressSuggestions;
const selectAddressError = instanceId => state => {
  return state.drools[instanceId].productCatalog.addressError;
};
exports.selectAddressError = selectAddressError;
const selectLowestPlanPrice = instanceId => state => {
  return state.drools[instanceId].productCatalog.lowestPlanPrice;
};
exports.selectLowestPlanPrice = selectLowestPlanPrice;
const selectSelectedAddress = instanceId => state => {
  return state.drools[instanceId].productCatalog.selectedAddress;
};
exports.selectSelectedAddress = selectSelectedAddress;